import { createSlice } from '@reduxjs/toolkit'

const eLearningRegistration = createSlice({
  name: 'registration',
  initialState: { data: {} },
  reducers: {
    resetData: (state) => {
      state.data = {}
    },
    setRegistrationData: (state, { payload }) => {
      state.data = payload
    },
  },
})

export const { resetData, setRegistrationData } = eLearningRegistration.actions

export default eLearningRegistration.reducer
